import { intervalToDuration } from 'date-fns';

export const calculateTenure = (startDate: string, endDate: string): string => {
  if (!startDate || !endDate) return '';

  const { years, months, days } = intervalToDuration({
    start: new Date(startDate),
    end: new Date(endDate),
  });

  const resultYears = years ? `${years}y ` : '';
  const resultMonths = months ? `${months}m ` : '';
  const resultDays = days ? `${days}d` : '';

  return `${resultYears} ${resultMonths} ${resultDays}`;
};
